import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, fileUrl } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import { useSeo } from "@/hooks/useSeo";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setPost(null); setNotFound(false);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  useSeo(post ? `${post.title} | StoneCrest` : "Article | StoneCrest", post?.excerpt, slug ? `https://stonecrestexteriors.co.uk/blog/${slug}` : undefined);

  if (notFound) return (
    <div className="px-6 py-40 text-center">
      <h1 className="font-serif text-4xl mb-4">Article not found</h1>
      <Link to="/blog" className="text-[var(--oxblood)] underline">Back to articles</Link>
    </div>
  );
  if (!post) return <div className="py-40 text-center text-[var(--muted)]">Loading…</div>;

  return (
    <div>
      <article className="px-6 md:px-12 max-w-3xl mx-auto pt-16 md:pt-24 pb-16">
        <Link to="/blog" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[var(--muted)] hover:text-[var(--oxblood)] transition-colors mb-8"><ArrowLeft className="w-4 h-4" /> All Articles</Link>
        <h1 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight" data-testid="blog-title">{post.title}</h1>
        {post.cover_image && (
          <Reveal className="mt-10">
            <div className="aspect-[16/9] overflow-hidden"><img src={fileUrl(post.cover_image)} alt={post.title} className="w-full h-full object-cover" /></div>
          </Reveal>
        )}
        <div className="mt-10 space-y-6 text-lg text-[var(--muted)] leading-relaxed">
          {post.content.split("\n\n").map((p, i) => <Reveal key={i} delay={i * 0.03}><p>{p}</p></Reveal>)}
        </div>
      </article>
      <CTASection />
    </div>
  );
}
